  <div class="dashboard-wrapper d-flex">
    <main class="flex-grow-1 px-2">
      <div class="rounded-lg  border-0 h-100 d-flex flex-column">
        
        <header class="p-3 flex-shrink-0">
          <h2 class="fw-bold fst-italic">Welcome back , {{ entity_name }}</h2>
          <p class="text-dark small">Review pending actions and trust management tasks.</p>
          
          <div class="alert alert-success border-0 d-flex align-items-center justify-content-between  mt-3">
            <div class="d-flex align-items-center gap-2">
              <i class="fas fa-exclamation-triangle fs-3"></i>
              <div>
                <strong class="d-block text-xs">5 KYC Documents Pending Review</strong>
                <span class="text-xxs">New beneficiary verification documents are awaiting your approval.</span>
              </div>
            </div>
            <button type="button" class="btn-close small" aria-label="Close"></button>
          </div>
        </header>

        <div class="dashboard-body flex-grow-1 px-3">
          <div class="row g-3 mb-4">
            <div class="col-md-3" v-for="stat in stats" :key="stat.label">
              <div class="glassy-table shadow-sm p-3 border rounded-lg h-100">
                <div class="icon-box mb-3" :class="stat.colorClass">
                  <i :class="stat.icon"></i>
                </div>
                <h3 class="fw-bold m-0 text-dark">{{ stat.value }}</h3>
                <p class="text-dark text-xs mb-1">{{ stat.label }}</p>
                <span class="text-xxs text-dark">{{ stat.subtext }}</span>
              </div>
            </div>
          </div>

          <div class="row g-4">
            <div class="col-lg-8">
                <div class="border rounded-lg p-3 h-100 glassy-table shadow-sm">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="d-flex align-items-center gap-2">
                        <div class="icon-box bg-light text-muted">
                        <i class="fas fa-file-alt"></i>
                        </div>
                        <div>
                        <h6 class="fw-bold m-0">Recent Documents</h6>
                        <small class="text-muted text-xxs">View-only building documents</small>
                        </div>
                    </div>
                    <a href="#" class="text-primary-blue text-xs fw-bold text-decoration-none">View All</a>
                    </div>

                    <div class="document-list">
                    <div v-for="doc in table_safe_company_list" :key="doc.id" 
                        class="document-item d-flex align-items-center justify-content-between p-3 mb-3 border rounded-lg hover-shadow">
                        <div class="d-flex align-items-center gap-3">
                        <div class="doc-icon-wrapper" :class="get_doc_color_class(doc.category)">
                            <i :class="doc.icon"></i>
                        </div>
                        <div>
                            <p class="fw-bold text-xs mb-1">{{ doc.name }}</p>
                            <div class="d-flex align-items-center text-xxs text-muted gap-2">
                            <span>{{ doc.category }}</span>
                            <span class="dot-separator"></span>
                            <span><i class="far fa-clock"></i> {{ doc.date }}</span>
                            </div>
                        </div>
                        </div>
                        <button class="btn btn-link text-muted p-0 border-0" @click="redirect_to_overview(doc.id)">
                        <i class="far fa-eye"></i>
                        </button>
                    </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4">
              <div class="border rounded-lg p-3 h-100 glassy-table shadow-sm">
                <h6 class="fw-bold mb-3">Upcoming Meetings</h6>
                <div class="meeting-list">
                  <div v-for="meeting in meetings" :key="meeting.id" class="meeting-item border-start border-white ps-3 mb-3">
                    <span class="badge bg-light text-success text-xxs mb-1 rounded-lg">{{ meeting.tag }}</span>
                    <p class="fw-bold text-xs mb-1">{{ meeting.title }}</p>
                    <div class="d-flex gap-2 text-xxs text-dark">
                      <span><i class="far fa-calendar"></i> {{ meeting.date }}</span>
                      <span><i class="far fa-clock"></i> {{ meeting.time }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row g-4 mt-1 mb-4">
            <div class="col-lg-8">
              <div class="border rounded-lg p-3 h-100 glassy-table shadow-sm">
                <h6 class="fw-bold mb-3">Action Center</h6>
                <div class="action-list">
                  <div v-for="action in actions" :key="action.id" 
                       class="action-item d-flex align-items-center justify-content-between p-3 mb-2 rounded-lg bg-light-soft">
                    <div class="d-flex align-items-center gap-3">
                      <span class="dot" :class="action.statusColor"></span>
                      <span class="text-xs fw-medium">{{ action.title }}</span>
                    </div>
                    <span class="text-xxs text-muted fw-bold">{{ action.type }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="border rounded-lg p-3 h-100 glassy-table shadow-sm">
                <div class="d-flex align-items-center gap-2 mb-3">
                  <div class="icon-box icon-yellow-light">
                    <i class="fas fa-wallet"></i>
                  </div>
                  <div>
                    <h6 class="fw-bold m-0">Distributions</h6>
                    <small class="text-muted text-xxs">Payment history</small>
                  </div>
                </div>

                <div class="mb-4">
                  <small class="text-dark text-xxs d-block">Total Distributed (YTD)</small>
                  <h4 class="fw-bold mb-1">R 7 050 000</h4>
                  <span class="text-primary-blue text-xxs fw-bold">
                    <i class="fas fa-arrow-trend-up"></i> +12.5% from last year
                  </span>
                </div>

                <div class="next-distribution p-3 rounded-lg border-success-light">
                  <small class="text-primary-blue text-xxs fw-bold">Next Distribution</small>
                  <h5 class="fw-bold mb-1">R 2 600 000</h5>
                  <small class="text-muted text-xxs">Expected on 15 Mar 2025</small>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </main>
  </div>